import { transactionsApi } from "@/apis/apis";
import BaseTable from "../BaseTable";
import { columns } from "./Columns";
import { useMemo } from "react";

export default function TransactionsPage() {
  const memoizedColumns = useMemo(() => columns, []);

  return (
    <BaseTable
      label="Transaction"
      apiURL={transactionsApi}
      columns={memoizedColumns()}
      enableAdd={false}
      enableActions={false}
      importData={null}
      enableExport={true}
      enableStatus={false}
      enableSortData={false}
    />
  );
}
